import {
  withReduxWrapper,
  withCSRWrapper,
  smartlook
} from 'components/AppShell'
import { getStore, GrowthBookUtils } from '@mafc/common'
import Braze from 'utils/braze'

const createGrowthBookInstance = GrowthBookUtils.createGrowthBookInstance

export {
  getStore,
  withReduxWrapper,
  withCSRWrapper,
  Braze,
  createGrowthBookInstance,
  smartlook
}

export {
  useFeature,
  IfFeatureEnabled,
  FeatureString,
  useGrowthBook,
  useExperiment,
  withRunExperiment
} from '@growthbook/growthbook-react'
